<template>
  <v-container class="w-100" fluid>
    <p class="text-center title mt-6 mb-0">
      {{
        $vuetify.lang.t("$vuetify.main.adminDashboard.psychologists.mainTitle")
      }}
    </p>
    <br />
    <UnmatchedPayments @assigned="load('active')" />
    <div style="display:flex;justify-content:center;align-items:center;flex-direction:column;">
      <div style="width:100%;max-width:300px;">
        <v-text-field
          v-model="searchInput"
          label="Пошук за прізвищем"
          prepend-inner-icon="mdi-magnify"
          clearable
          hide-details
          class="mb-4"
        />
      </div>
      <span>Статус:</span>
      <div style="width:100%;max-width:300px;">
        <v-select
          v-model="selectedAdminStatus"
          :items="translatedStatuses"
          item-value="id"
          item-text="title"
        />
      </div>
      <br />
      <span>Тег:</span>
      <div style="width:100%;max-width:300px;">
        <v-select
          v-model="selectedAdminTag"
          :items="translatedTags"
          item-value="id"
          item-text="title"
        />
      </div>
    </div>
    <div v-if="currentKind === 'active'" class="unpaid-placement">
      <span>{{ upt("title") }}:</span>
      <v-text-field
        v-model.number="unpaidDays"
        class="unpaid-placement__days"
        type="number"
        min="1"
        max="3650"
        dense
        outlined
        hide-details
        :suffix="$vuetify.lang.t('$vuetify.main.adminDashboard.psychologists.placement.days')"
      ></v-text-field>
      <v-btn small color="primary" :loading="unpaidBusy" @click="askUnpaidPlacement">{{ upt("apply") }}</v-btn>
    </div>
    <v-dialog v-model="unpaidDialog" max-width="460">
      <v-card>
        <v-card-title class="text-h6">{{ upt("confirmTitle") }}</v-card-title>
        <v-card-text>{{ unpaidConfirmText }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="unpaidDialog = false">{{ upt("cancel") }}</v-btn>
          <v-btn color="primary" :disabled="!unpaidCount" :loading="unpaidBusy" @click="applyUnpaidPlacement">{{ upt("confirm") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="mt-3">
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab v-for="kind in kinds" :key="kind">
          {{
            $vuetify.lang.t(
              `$vuetify.main.adminDashboard.psychologists.tabs.${tabLabels[kind]}`
            )
          }}<span v-if="total[kind] !== null" class="ml-1">({{ total[kind] }})</span></v-tab
        >
        <div class="align-self-center ml-auto pr-4">
          <a @click="downloadDocument" class="white--text">{{
            $vuetify.lang.t(
              "$vuetify.main.adminDashboard.psychologists.buttons.downloadAll"
            )
          }}</a>
          <a @click="downloadContacts" class="white--text ml-4">Email і телефони (CSV)</a>
        </div>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="kind in kinds" :key="kind">
          <v-row v-if="loading[kind]" class="pt-16 pb-16">
            <v-col cols="12" md="12 text-center">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-col>
          </v-row>
          <psychologistCards
            v-else
            @reload="loading[kind] = true"
            @reloadpage="loadAll"
            :psychologists="lists[kind]"
            :inactive="kind !== 'active'"
            :archived="kind === 'archived'"
          />
        </v-tab-item>
      </v-tabs-items>
      <v-row justify="center" class="mt-8 mb-8" v-if="lastPage[currentKind] > 1">
        <div class="text-center" style="margin-top: -30px;">
          <v-pagination
            :value="page[currentKind]"
            @input="changePage"
            :length="lastPage[currentKind]"
            :total-visible="10"
          ></v-pagination>
        </div>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import ApiClient from "@/libs/http-client";
import Vue from "vue";
import psychologistCards from "@/components/dashboard/adminDashboard/psychologistCards";
import UnmatchedPayments from "@/components/dashboard/adminDashboard/UnmatchedPayments";
import AdminServices from "@/services/api/admin.services";

// tab, status, tag and pages survive leaving the page and reloading it
const STORAGE_KEY = "adminPsychologistsFilters";

const readSaved = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
};

export default {
  name: "psychologistsComponent",
  components: {
    psychologistCards,
    UnmatchedPayments,
  },
  metaInfo() {
    return {
      title:
        "Платформа / " +
        this.$vuetify.lang.t("$vuetify.main.header.menu.psychologists"),
    };
  },
  data() {
    const saved = readSaved();
    return {
      kinds: ["new", "active", "deactivated", "archived"],
      total: { new: null, active: null, deactivated: null, archived: null },
      tabLabels: {
        new: "inactivePsychologists",
        active: "activePsychologists",
        deactivated: "deactivatedPsychologists",
        archived: "archivedPsychologists",
      },
      tab: Number.isInteger(saved.tab) ? saved.tab : 0,
      selectedAdminStatus: saved.status || 0,
      selectedAdminTag: saved.tag || 0,
      searchInput: saved.search || "",
      search: saved.search || "",
      page: { new: 1, active: 1, deactivated: 1, archived: 1, ...(saved.page || {}) },
      lastPage: { new: 1, active: 1, deactivated: 1, archived: 1 },
      loading: { new: true, active: true, deactivated: true, archived: true },
      unpaidDays: 180,
      unpaidCount: null,
      unpaidDialog: false,
      unpaidBusy: false,
    };
  },
  beforeMount() {
    this.loadAll();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  watch: {
    tab() {
      this.save();
    },
    selectedAdminStatus() {
      this.onFilterChange();
    },
    selectedAdminTag() {
      this.onFilterChange();
    },
    // typing is debounced: the lists reload 400 ms after the last key
    searchInput(value) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        const next = (value || "").trim();
        if (next !== this.search) {
          this.search = next;
          this.onFilterChange();
        }
      }, 400);
    },
  },
  computed: {
    currentKind() {
      return this.kinds[this.tab] || "new";
    },
    unpaidConfirmText() {
      return this.upt(this.unpaidCount ? "confirmText" : "nobody")
        .replace("{count}", this.unpaidCount)
        .replace("{days}", this.unpaidDays);
    },
    lists() {
      return {
        new: this.$store.getters["user/getInactivePsychologists"],
        active: this.$store.getters["user/getActivePsychologists"],
        deactivated: this.$store.getters["user/getDeactivatedPsychologists"],
        archived: this.$store.getters["user/getArchivedPsychologists"],
      };
    },
    translatedStatuses() {
      return [0, 1, 2, 3, 4, 5, 6, 7, 8].map(i => ({
        id: i,
        title: this.$vuetify.lang.t(`$vuetify.main.adminDashboard.psychologists.admin_status.${i}`)
      }));
    },
    translatedTags() {
      return [0, 1, 2].map(i => ({
        id: i,
        title: this.$vuetify.lang.t(`$vuetify.main.adminDashboard.psychologists.profile_tag.${i}`)
      }));
    }
  },
  methods: {
    save() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          tab: this.tab,
          status: this.selectedAdminStatus,
          tag: this.selectedAdminTag,
          search: this.search,
          page: this.page,
        }));
      } catch (e) {
        // storage unavailable: filters just won't be remembered
      }
    },
    load(kind) {
      const actions = {
        new: "user/getInactivePsychologists",
        active: "user/getActivePsychologists",
        deactivated: "user/getDeactivatedPsychologists",
        archived: "user/getArchivedPsychologists",
      };
      this.loading[kind] = true;
      return this.$store.dispatch(actions[kind], {
        page: this.page[kind],
        admin_status_id: this.selectedAdminStatus,
        profile_tag_id: this.selectedAdminTag,
        search: this.search,
      })
        .then((response) => {
          // a newer request of this list is on its way: it sets the list and the counters
          if (response.stale) return;
          const last = response.data.meta.last_page || 1;
          // how many psychologists are in the tab (with the current search and filters)
          this.total[kind] = response.data.meta.total;
          this.lastPage[kind] = last;
          // after activating/deleting the current page may no longer exist
          if (this.page[kind] > last) {
            this.page[kind] = last;
            this.save();
            return this.load(kind);
          }
        })
        .catch(() => {
          // the server did not answer: the list keeps what it showed, the spinner goes away
        })
        .finally(() => {
          this.loading[kind] = false;
        });
    },
    loadAll() {
      this.kinds.forEach((kind) => this.load(kind));
    },
    // kept for psychologistCards, which emits "reloadpage" after changes
    reloadPage() {
      this.loadAll();
    },
    onFilterChange() {
      this.kinds.forEach((kind) => {
        this.page[kind] = 1;
      });
      this.save();
      this.loadAll();
    },
    changePage(value) {
      this.page[this.currentKind] = value;
      this.save();
      this.load(this.currentKind);
    },
    upt(key) {
      return this.$vuetify.lang.t(`$vuetify.main.adminDashboard.psychologists.unpaidPlacement.${key}`);
    },
    // free placement for every approved psychologist without payment: count first, then confirm
    askUnpaidPlacement() {
      const days = parseInt(this.unpaidDays, 10);
      if (!(days >= 1 && days <= 3650)) {
        this.unpaidDays = 180;
        return;
      }
      this.unpaidBusy = true;
      AdminServices.get("unpaidPlacement")
        .then((response) => {
          this.unpaidCount = response.data.data.count;
          this.unpaidDialog = true;
        })
        .finally(() => {
          this.unpaidBusy = false;
        });
    },
    applyUnpaidPlacement() {
      this.unpaidBusy = true;
      AdminServices.post("unpaidPlacement", {}, { days: parseInt(this.unpaidDays, 10) })
        .then((response) => {
          this.unpaidDialog = false;
          Vue.swal({
            target: document.getElementById("main"),
            text: response.data.message,
            icon: "success",
            timer: 5000,
            toast: true,
            position: "top-right",
            showConfirmButton: false,
          });
          this.loadAll();
        })
        .finally(() => {
          this.unpaidBusy = false;
        });
    },
    downloadDocument() {
      this.$store.dispatch("user/downloadPsychologistInfo");
    },
    // every registered psychologist (active and not) with email and phone, newest first
    downloadContacts() {
      ApiClient.get("api/admin/psychologists/export-contacts", { responseType: "blob" }).then((response) => {
        if (!response) return;
        const link = document.createElement("a");
        link.href = URL.createObjectURL(response.data);
        link.download = "psychologists-" + new Date().toISOString().slice(0, 10) + ".csv";
        link.click();
        setTimeout(() => URL.revokeObjectURL(link.href), 1000);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.unpaid-placement {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 16px;
}
.unpaid-placement__days {
  flex: 0 0 120px;
}
</style>